import React from 'react';
import { NewFlagProps, SquareVerticalContentUnit } from '@design-system/pc';
import { ContentsSettingDataResponse } from '@display-component/shared';
import useExpertSlideItem from './hooks/useExpertSlideItem';
import TrackingService from '@/services/tracking';

interface ExpertSlideItemProps {
  item: ContentsSettingDataResponse;
  initialScrap: boolean;
  handleMutateScrapList: () => void;
}

const ExpertSlideItem = ({
  item,
  initialScrap,
  handleMutateScrapList,
}: ExpertSlideItemProps) => {
  const { hasScrap, handleScrap, handleClickItem } = useExpertSlideItem({
    item,
    initialScrap,
  });

  return (
    <SquareVerticalContentUnit
      img={item.imageInfo?.images?.[0]?.imageUrl}
      imgFlags={item?.imageInfo?.tagInfo?.map((tag) => {
        return {
          variant: tag.style || '',
          textColor: tag.textColor || '',
          color: tag.styleColor || '',
          content: tag.name || '',
        } as NewFlagProps;
      })}
      isShowBookmark={item.isScrap}
      isCheckedBookmark={hasScrap}
      title={item.contentsTitle}
      info1={item.squareMeter}
      info2={item.cityCountryDistrict}
      handleClick={handleClickItem}
      handleClickBookmark={() => {
        handleScrap();
        handleMutateScrapList();
      }}
      {...TrackingService.tagGTM('expert_construction_case_slide_item', {
        'content-id': item.contentsNo,
      })}
    />
  );
};

export default ExpertSlideItem;
